import { Tool } from '../../data/tools';

export const metadata: Tool = {
  id: 'on-this-day',
  name: 'On This Day in History',
  description: 'Explore historical milestones, births, deaths, and holiday events for any day of the year.',
  category: 'Explore',
  icon: 'Calendar',
  route: '/tools/on-this-day',
  metaTitle: 'On This Day in History — Daily Historical Events & Births Explorer',
  metaDescription: 'Discover significant historical events, famous births, notable deaths, and national holidays for any day of the year. Backed by verified Wikipedia historical records.',
  keywords: [
    'on this day in history',
    'historical events today',
    'who was born on this day',
    'on this day events',
    'today in history',
    'wikipedia historical feed',
    'historical events calendar'
  ],
  longDescription: 'The On This Day in History tool parses public Wikipedia history datasets to show users what major events, births, deaths, and holidays occurred on any selected month and day of the calendar year. Users can filter by event type to easily browse historical timelines.',
  howToUse: [
    'Select any month and day of the calendar year using the control dropdowns.',
    'Switch between tabs (Events, Births, Deaths, Holidays) to filter results.',
    'Read brief summaries of each event along with links to full Wikipedia articles.',
    'Filter search results by typing keywords into the search box.'
  ],
  benefits: [
    'Pulls live, comprehensive historical summaries directly from Wikipedia REST archives.',
    'Zero-auth required, loading directly on the user\'s local client.',
    'Excellent educational tool for students, teachers, trivia lovers, and history buffs.'
  ],
  faq: [
    {
      question: 'Where does the history data come from?',
      answer: 'The data is sourced directly from Wikipedia\'s public API endpoints, which aggregate verified community-curated historical milestones, birthdays, and records.'
    },
    {
      question: 'Can I search by calendar year?',
      answer: 'This tool is structured around day-of-year anniversaries (e.g. what happened on June 28th across all years). You can easily filter the search or scroll through the chronological timeline to find specific years.'
    },
    {
      question: 'Is this historical feed available in other languages?',
      answer: 'Currently, the tool queries the English edition of Wikipedia\'s historical database to ensure the most comprehensive coverage of global milestones.'
    }
  ]
};
